<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Leadership Message</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>Leadership Message</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- teacher details widget start here-->
        <section class="bd-teacher-widget-area pb-70 pt-120">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <div class="bd-teacher-widget-thumb p-relative">
                                <img src="/img/general/L1.png" alt="img not found!">
                                <div class="panel wow"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-teacher-widget-content">
                                <h3 class="bd-teacher-widget-title">Anil Agarwal</h3>
                                <span class="bd-teacher-widget-tag">Chairman, Vedanta Resources Limited, and Anil
                                    Agarwal
                                    Foundation</span>
                                <p> Education is the key to unlock the limitless potential within every individual. It
                                    should
                                    not be a privilege reserved for a select few, but a right accessible to all. At
                                    Vedanta
                                    Foundation, we are committed to making quality education a reality for every
                                    aspiring
                                    mind, empowering them to dream, innovate, and build a better future for themselves
                                    and the
                                    Nation.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-teacher-widget-content">
                                <h3 class="bd-teacher-widget-title">Suman Didwania</h3>
                                <span class="bd-teacher-widget-tag">Trustee, Vedanta Foundation</span>
                                <p>The Vedanta Foundation provides quality education and livelihood opportunities to the
                                    less privileged, making a difference through healthcare, education, skilling, and
                                    livelihood programs. Baburam Vedanta Public School, a non-profit institution under
                                    the Foundation, proudly offers affordable, high-quality education to bright young
                                    minds in Bharatpur and nearby villages, with a vision to make quality education
                                    accessible to all.</p>
                                <p>Our focus extends beyond academics, nurturing well-rounded individuals by emphasizing
                                    on co-curricular activities, sports, and character development, facilitated by our
                                    dedicated faculty. We actively engage with parents and the community, fostering a
                                    collaborative learning environment</p>
                                <p>Together, we empower minds, instil values, and illuminate the path to success for the
                                    children of Bharatpur. Thank you for choosing us as your partner on this educational
                                    journey.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <div class="bd-teacher-widget-thumb p-relative">
                                <img src="/img/general/L2.png" alt="img not found!" style="height: 478px;">
                                <div class="panel wow"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- teacher details widget end here-->

    </main>
</template>
<script>
export default {
    name: "LeadershipMessageView",
};
</script>
